// extracted by mini-css-extract-plugin
module.exports = {"achievementCard":"style_achievementCard__3VnqE","selectdiv":"style_selectdiv__2P_jS","select":"style_select__2gZHp","selected":"style_selected__2UoWM","link":"style_link__3w0fk"};